module.exports = __webpack_public_path__ + "static/media/the-people-building-edible-cities.f62a987c.jpg";